// src/components/originator-pending.js

import React, { useState, useEffect, Fragment} from 'react'
import { RestHelper } from '../helper/restHelper'
import { ApptNotesHandler, GeneralFileUpload, GeneralUploadStatus, GeneralGroupFileUpload } from '../components'



const NotaryViewRequestDetails = (data) => {  

  const [requestDetails, setRequestDetails] = useState([])
  const [isLoaded, setIsLoaded] = useState(false)
  const [showDetails, setShowDetails] = useState(true)
  const [showResponse, setShowResponse] = useState(false)
  const [updateResponse, setUpdateResponse] = useState([])
  const [showFileUpload, setShowFileUpload] = useState(false)
  const [showMessageCenter, setShowMessageCenter] = useState(false)
  const [showEscrow, setShowEscrow] = useState(false)
  const api = RestHelper()

  useEffect(() => {
    const reqData = { data }
    const options = {}
    console.log(data)
    if (data.status === 'scheduled') {
      setShowFileUpload(true)
      setShowEscrow(true)
    }
    if (data.status === 'scheduled') {
      setShowMessageCenter(true)
    }
    if(!isLoaded){
    api
        .postCreate('/get-request-details', options, reqData)
        .then(res => loadRequestDetails(res))
        .catch(err => console.log(err))
    setIsLoaded(true)
    }
  },[])

  function loadRequestDetails(res) {
    setRequestDetails(res)
    // notary is allowed to upload files for 72 hours after the file
    if (isWithin72Hours(res[0].apptNumericalTime) && (data.status === 'completed')){
      setShowFileUpload(true)
      setShowMessageCenter(true)
    }
  }


  function isWithin72Hours(epochTime) {
    // Convert epoch time to Date object
    const givenTime = new Date(epochTime*1000);
 
    // Get the current time
    const currentTime = new Date();
  
    // Calculate the difference in milliseconds
    const timeDifference = currentTime - givenTime;
  
    // Convert 72 hours to milliseconds
    const seventyTwoHours = 72 * 60 * 60 * 1000;
  
    // Check if the difference is more than 72 hours
    return timeDifference <= seventyTwoHours;
  }

  function clearResponseMessage() {
    if (data.status === 'scheduled') {
      setShowFileUpload(true)
      setShowEscrow(true)
    }
    const reqData = { data }
    const options = {}
    api
      .postCreate('/get-request-details', options, reqData)
      .then(res => setRequestDetails(res))
      .catch(err => console.log(err))
  }

  const scanBackCheck = (checkFlag) => {
    var scanBackValue = ''
    if (checkFlag === 'true') {
      scanBackValue = 'SCAN BACKS ARE REQUIRED'
    }
    else{
      scanBackValue = 'NONE'
    }
    return scanBackValue

  }

  function setTransactionType(setValue) {
    if (setValue === '0') {
      return 'Not Defined'
    }
    else if (setValue === '1') {
      return 'Purchase (Buyer Side)'
    }
    else if (setValue === '2') {
      return 'Refinance'
    }
    else if (setValue === '3') {
      return 'Seller Side Closing'
    }
    else if (setValue === '4') {
      return 'Other'
    }
    else {
      return 'Not Defined'
    }
  }

  function setFinanceType(setValue) {
    if (setValue === '10') {
      return 'Not Defined'
    }
    else if (setValue === '11') {
      return 'FHA'
    }
    else if (setValue === '12') {
      return 'Conventional'
    }
    else if (setValue === '13') {
      return 'Reverse'
    }
    else if (setValue === '14') {
      return 'HELOC'
    }
    else if (setValue === '15') {
      return 'Commercial'
    }
    else if (setValue === '16') {
      return 'VA'
    }
    else {
      return 'Not Defined'
    }
  }

  const dateFormat = (inputDate) => {
    const dateArray = inputDate.split("-")
    const date = dateArray[1] + '/' + dateArray[2] + '/' + dateArray[0]
    return date
  }
  function convertToSimpleDateMessage(updatedTime) {
    const date = new Date(updatedTime*1000)
    const dateString = date.toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    })
    return dateString
  }

  const getTempUrl = (e) => {
    const options = {}
    const fileData = {'unique_id' : data.requestId, 'file_name' : e }
    api
        .postCreate('/get-stored-file', options, fileData)
        .then(res => window.open(res.get_url,"_blank"))
        .catch(err => console.log(err))
    }

    
      const handleDownload = (res, filename) => {
        const fileUrl = res.get_url; 
    
        fetch(fileUrl)
          .then((response) => response.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); // Replace with your desired file name and extension
            document.body.appendChild(link);
            link.click();
            link.remove();
          })
          .catch((error) => {
            console.error('Error downloading file:', error);
          });
      }; 
      function setAction(passedAction) {
        if (passedAction === 'write') {
          return 'Uploaded'
        }
        else {
          return 'Downloaded'
        }
      }

  const formatPhoneNumber = (phone) => {
    if (!phone) return '';
    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, '');
    // Format as (XXX) XXX-XXXX if 10 digits
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    // Return original if not 10 digits
    return phone;
  }


  return(
   <div className="w-full">
    {showDetails && (<div>
    {requestDetails.map((items =>
            <div key={items.appt_requestId}>
            {/* Appointment Details Card */}
            <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
              <div className="px-3 sm:px-5 py-3 border-b border-neutral-200">
                <h2 className="text-lg font-semibold text-neutral-800">{items.apptName} Details</h2>
                <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
              </div>
              <div className="p-3 sm:p-5 space-y-3">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className='font-medium text-neutral-600'>Appointment Name</div>
                  <div className='sm:col-span-2 text-neutral-800 break-words'>{items.apptName}</div>
                </div>
                {items.notaryStatus.map(items2 =>
                <div key={items2.apptNotaryBid}>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                    <div className='font-medium text-neutral-600'>Status</div>
                    <div className='sm:col-span-2 text-neutral-800'>{items2.apptNotaryApproval}</div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className='font-medium text-neutral-600'>Signing Agent Fee</div>
                  <div className='sm:col-span-2 text-neutral-800'>${items2.apptNotaryBid}</div>
                </div>
                </div>
                )}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className='font-medium text-neutral-600'>When</div>
                  <div className='sm:col-span-2 text-neutral-800'>{dateFormat(items.apptDate)} at {items.apptTime} {items.appt_timeZone}</div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className='font-medium text-neutral-600'>Where</div>
                  <div className='sm:col-span-2 text-neutral-800 break-words'>{items.apptStreet} {items.apptCity}, {items.apptState} {items.apptZip}</div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className='font-medium text-neutral-600'>Lender</div>
                  <div className='sm:col-span-2 text-neutral-800 break-words'>{items.lender}</div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                    <div className="font-medium text-neutral-600">Scan Backs</div>
                    <div className="sm:col-span-2 text-neutral-800">{scanBackCheck(items.scanBack)}</div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                    <div className="font-medium text-neutral-600">Transaction Type</div>
                    <div className="sm:col-span-2 text-neutral-800">{setTransactionType(items.transactionType)}</div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                    <div className="font-medium text-neutral-600">Finance Type</div>
                    <div className="sm:col-span-2 text-neutral-800">{setFinanceType(items.financeType)}</div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className='font-medium text-neutral-600'>Extra Notes</div>
                  <div className='sm:col-span-2 text-neutral-800 break-words whitespace-pre-wrap'>{items.apptMessages}</div>
                </div>
              </div>
            </div>

            {/* Contacts Card */}
            {showEscrow && (
            <div className="bg-white rounded-xl shadow-md border border-neutral-200 mt-4 overflow-hidden">
              <div className="px-3 sm:px-5 py-3 border-b border-neutral-200">
                <h2 className="text-lg font-semibold text-neutral-800">Contacts</h2>
                <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
              </div>
              <div className="p-3 sm:p-5 space-y-3">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className='font-medium text-neutral-600'>Escrow Officer</div>
                  <div className='sm:col-span-2 text-neutral-800 break-words'>{items.escrowName} - {items.escrowPhone && (
                      <a href={`tel:${items.escrowPhone.replace(/\D/g, '')}`} className="text-blue-600 hover:text-blue-800 hover:underline">
                        {formatPhoneNumber(items.escrowPhone)}
                      </a>
                    )}</div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className='font-medium text-neutral-600'>Escrow Email</div>
                  <div className='sm:col-span-2 text-neutral-800 break-words'>
                    <a href={`mailto:${items.escrowEmail}`} className="text-blue-600 hover:text-blue-800 hover:underline">{items.escrowEmail}</a>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className="font-medium text-neutral-600">Signer Name</div>
                  <div className="sm:col-span-2 text-neutral-800 break-words">{items.apptContactName}</div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className="font-medium text-neutral-600">Signer Phone Primary</div>
                  <div className="sm:col-span-2 text-neutral-800">
                    {items.apptContactPhone1 && (
                      <a href={`tel:${items.apptContactPhone1.replace(/\D/g, '')}`} className="text-blue-600 hover:text-blue-800 hover:underline">
                        {formatPhoneNumber(items.apptContactPhone1)}
                      </a>
                    )}
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className="font-medium text-neutral-600">Signer Phone Secondary</div>
                  <div className="sm:col-span-2 text-neutral-800">
                    {items.apptContactPhone2 && (
                      <a href={`tel:${items.apptContactPhone2.replace(/\D/g, '')}`} className="text-blue-600 hover:text-blue-800 hover:underline">
                        {formatPhoneNumber(items.apptContactPhone2)}
                      </a>
                    )}
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className="font-medium text-neutral-600">Signer Email Primary</div>
                  <div className="sm:col-span-2 text-neutral-800 break-words">
                    {items.apptContactEmail1 && (
                      <a href={`mailto:${items.apptContactEmail1}`} className="text-blue-600 hover:text-blue-800 hover:underline">{items.apptContactEmail1}</a>
                    )}
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-2 border-b border-neutral-100">
                  <div className="font-medium text-neutral-600">Signer Email Secondary</div>
                  <div className="sm:col-span-2 text-neutral-800 break-words">
                    {items.apptContactEmail2 && (
                      <a href={`mailto:${items.apptContactEmail2}`} className="text-blue-600 hover:text-blue-800 hover:underline">{items.apptContactEmail2}</a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            )}

            {/* File Management Card */}
            <div className="bg-white rounded-xl shadow-md border border-neutral-200 mt-4 overflow-hidden">
              <div className="px-3 sm:px-5 py-3 border-b border-neutral-200">
                <h2 className="text-lg font-semibold text-neutral-800">File Management</h2>
                <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
              </div>
              <div className="p-3 sm:p-5">
                {showFileUpload && (
                  <div className="mb-6">
                    <GeneralGroupFileUpload requestId={data.requestId} clearResponseMessage={clearResponseMessage}/>
                  </div>
                )}

                {/* File Attachment List */}
                <div>
                  <h3 className="font-medium text-neutral-700 mb-3">
                    File Attachment List
                    <span className="text-sm text-neutral-500 font-normal ml-2">(files may not be accessible via mobile device)</span>
                  </h3>
                  {items.fileLogInfo && items.fileLogInfo.length > 0 ? (
                    <div className="bg-neutral-50 rounded-lg border border-neutral-200 divide-y divide-neutral-200">
                      {items.fileLogInfo.map(o => (
                        <div className="p-3" key={o.fileName}>
                          <button
                            className="text-blue-600 hover:text-blue-800 hover:underline text-left font-medium"
                            title="Download File"
                            type="button"
                            onClick={() => getTempUrl(o.fileName)}
                          >
                            {o.fileName}
                          </button>
                          <div className="mt-2 text-sm text-neutral-500 space-y-1">
                            {o.fileReadInfo.map(info => (
                              <div key={info.loggedTime} className="flex items-center gap-2">
                                <span>{setAction(info.action)} by {info.user} - {convertToSimpleDateMessage(info.loggedTime)}</span>
                                <GeneralUploadStatus confirm={info.confirmed} action={info.action}/>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-neutral-500 text-sm">No files attached</p>
                  )}
                </div>
              </div>
            </div>
          
          {showMessageCenter && (
            <div className="mt-4">
              <ApptNotesHandler requestId={data.requestId} role={data.role}/>
            </div>
          )}
            </div>
            ))}</div>)
  }
  {showResponse &&
   <div>
    {updateResponse.map((items =>
      <div>
        {items.message}
      </div>
    ))}
    </div>
}
            
</div>
  )
};

export default NotaryViewRequestDetails;